<script lang="ts">
    import Vue from "vue";
    import Component from 'vue-class-component';
    import { EditorState } from "@common/Common";
    import { CostSubtotalEditorViewModel, CreateCostSubtotalEventPayload, RenameCostSubtotalEventPayload } from "@Quest/Financials/Costs/Components/CostSubtotalEditor";

    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class CostSubtotalEditor extends Vue
    {
        get vm(): CostSubtotalEditorViewModel { return this.$props.viewModel as CostSubtotalEditorViewModel; }
        get opened(): boolean { return this.vm?.opened; }
        get confirmButtonLabel(): string { return this.vm.state === EditorState.Creator ? 'Create' : 'Update'; }
        get modalTitle(): string { return this.vm.state === EditorState.Creator ? 'Create subtotal' : 'Edit subtotal'; }

        get name(): string | null { return this.vm.name; }
        set name(val: string | null) { this.vm.name = val; }

        handleFormSubmit()
        {
            if (this.vm.state === EditorState.Creator)
            {
                this.$emit("create-subtotal", new CreateCostSubtotalEventPayload(this.name));                
            }
            else if (this.vm.state === EditorState.Editor)
            {
                this.$emit("rename-subtotal", new RenameCostSubtotalEventPayload(this.vm.id, this.name));
            }
        }

        close()
        {
            this.vm.close();
        }
    }
</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ modalTitle }}</h5>
                        <button @click="close" type="button" class="close">&times;</button>
                    </div>
                    <div class="modal-body">
                        <form id="cost-subtotal-editor-form" @submit.prevent="handleFormSubmit">
                            <div class="form-group">
                                <label>Name:</label>
                                <input type="text" v-model.trim="name" class="form-control" required maxlength="100" minlength="2" />
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" @click="close" class="btn btn-outline-secondary">Cancel</button>
                        <button type="submit" form="cost-subtotal-editor-form" class="btn btn-primary">{{ confirmButtonLabel }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>